import React from 'react';
import './three-dots-loader.styles.scss';

const ThreeDotsLoader = ({
    noPad,
    small
}) => {
    return (
        <div className={`three-dots-loader ${small ? 'small' : ''}`}>
            <div className={`loading ${noPad ? 'no-pad' : ''}`}>
                <span className="loading__dot"></span>
                <span className="loading__dot"></span>
                <span className="loading__dot"></span>
            </div>
        </div>
    )
}

export default ThreeDotsLoader